import { SxProps, useTheme } from '@mui/material';

import { useMytaverse } from '@providers/MytaverseProvider';
import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  const {
    submitButton: { backgroundColorHover },
  } = appTheme.avatarPage.assets;

  return {
    root: {
      '& .MuiBackdrop-root': {
        backgroundColor: 'transparent',
      },
    },
    container: {
      display: 'flex',
      gap: 0.5,
      flexDirection: 'column',
      justifyContent: 'start',
      padding: 2,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 838,
      background: '#0C0B0B99',
      borderRadius: 6,
      maxHeight: '90vh',
      maxWidth: '90vw',
      overflow: 'auto',
      backdropFilter: 'blur(40px)',
      border: '1.6px solid rgba(255, 255, 255, 0.25)',

      '&:focus-visible': {
        outline: 'none',
      },

      [breakpoints.down(ScreenSizes.PcWide)]: {
        width: 712,
        maxHeight: '80dvh',
        maxWidth: '80dvw',
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: 300,
        padding: 1,
        maxHeight: '90dvh',
        maxWidth: '90dvw',
      },
    } as SxProps,
    closeIcon: {
      position: 'absolute',
      top: 20,
      right: 20,
      color: colors.grey_200,
      fontSize: 18,
      cursor: 'pointer',

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        top: 10,
        right: 10,
        fontSize: 20,
      },
    },
    title: {
      fontFamily: 'Primary-Bold',
      fontWeight: 700,
      fontSize: 32,
      lineHeight: 1,
      color: colors.white,
      marginBottom: 2.5,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 22,
        marginBottom: 1.5,
      },
    },
    content: {
      display: 'flex',
      background: '#0C0B0B99',
      borderRadius: 4,
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      gap: 1,
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',

      '@media (max-width: 767px)': {
        gap: 2,
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        display: 'none',
      },
    },
    info: {
      color: colors.white,
      background: '#0C0B0B66',
      borderRadius: '99px',
      backdropFilter: 'blur(40px)',
      py: 1,
      px: 2,
      fontSize: 14,
      lineHeight: 1.35,
      display: 'flex',
      alignItems: 'center',
      gap: 0.5,

      '& svg': {
        fontSize: 16,
      },
    },
  };
};
